import { render, staticRenderFns } from "./Scenarios.vue?vue&type=template&id=32652d2c&scoped=true&"
import script from "./Scenarios.vue?vue&type=script&lang=js&"
export * from "./Scenarios.vue?vue&type=script&lang=js&"
import style0 from "./Scenarios.vue?vue&type=style&index=0&id=32652d2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32652d2c",
  null
  
)

export default component.exports